<template>
  <div class="open" style="padding: 0 1em; text-align: left">
    <div style="text-align: left; padding: 0.5rem 2rem">
      <div v-html="content" />
      <select v-model="placeno" @change="getDate2()">
        <option value="" selected>請選擇</option>
        <option value="1110000">青永館前廣場貴賓停車位14格</option>
        <option value="1211000">行政大樓1F前廣場停車位4格</option>
        <option value="1611000">圖書資訊館1F前圓環貴賓停車位9格</option>
        <option value="2000000">後門草皮臨時停車場90格</option>
        <option value="2100000">前門草皮臨時停車場150格</option>
      </select>
    </div>
    <div style="text-align: center; padding: 0.5rem 1rem; display: flex">
      <v-calendar :masks="{ title: 'YYYY MMM' }"
        is-expanded
        :disabled-dates="{ weekdays: [1, 7] }"
        :attributes="attributes" @update:from-page="pageChange"
      >
        <template v-slot:day-content="{ day, attributes }">

      <div id="test1" v-if="( getyearmonthday_com1 (day.day) )" class="Block_shadow_3" >

            <span   class="Block_shadow_2" >{{ day.day }}</span>
            <div   >
              <p v-for="attr in attributes"
                :key="attr.key"
                class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                :class="attr.customData.class">
                {{ attr.customData.orderna }} {{ attr.customData.ordstime }} :
                {{ attr.customData.ordetime }} 預約台數:{{
                  attr.customData.mcarnum
                }}
              </p>

            </div>
      </div>

        <div id="test2" v-else>

            <span  @click="show_Modal('0',day,day.day,user.id,'0900','1000')" class="Block_shadow_2" >{{ day.day }}</span>
            <div   >
              <p v-for="attr in attributes"
                :key="attr.key"
                class="Block_shadow_2"
               :class="attr.customData.class" @click="show_Modal(attr.customData.orderno,day,day.day,attr.customData.orderid,attr.customData.ordstime,attr.customData.ordetime)" >
                {{ attr.customData.orderna }}
                {{ attr.customData.ordstime }} : {{ attr.customData.ordetime }}
                預約台數:{{ attr.customData.mcarnum }}

              </p>
            </div>

      </div>

        </template>
      </v-calendar>
    </div>
      <b-modal size="xl" ref="ePlace" hide-footer >
        <template #modal-title>
          日曆新增記錄 ‖ {{modalTitle}}
        </template>
        <ePlace :maxcarnum=maxcarnum :ordstime=ordstime :ordetime=ordetime  :id=editId :placeno=placeno :selectedDay=selectedDay :date=date @hideModal="hideModal"/>
      </b-modal>

  </div>
</template>

<script>
import ePlace from '@/components/CalendarEditPlace.vue'
import * as tools from '../tool'

export default {
  name: 'open',
  data () {
    return {
      maxcarnum: null,
      ordstime: null,
      ordetime: null,
      selectedDay: null,
      days: [],
      masks: {
        weekdays: 'WWW'
      },
      content: '',
      placeno: '1110000',
      editId: 0,
      is_show: false,
      today1: null,
      mm: null,
      yyyy: null,
      mm1: null, // 月曆月
      yyyy1: null, // 月曆年
      date: null
    }
  },
  components: {
    ePlace
  },
  computed: {
    modalTitle () {
      return (this.editId > 0 ? '編輯' : '新增')
    },
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    },
    dates () {
      return this.days.map((day) => day.sdate)
    },
    attributes () {
      return this.days.map((date) => ({
        dates: date.sdate,
        customData: {
          orderid: date.orderid,
          orderno: date.orderno,
          orderna: date.orderna,
          ordstime: date.ordstime,
          ordetime: date.ordetime,
          mcarnum: date.mcarnum,
          class: 'bg-red-600 text-white'

        }

      }))
    }
  },

  methods: {
    getyearmonthday_com1 (day) {
      // 月曆年月日

      var calyyyymmdd = parseInt(String(this.yyyy1) + String(this.mm1).padStart(2, '0') + String(day).padStart(2, '0'))
      // 目前年月日
      var yyyymmdd = parseInt(String(this.yyyy) + String(this.mm).padStart(2, '0') + String(this.today1).padStart(2, '0'))
      var r1 = calyyyymmdd < yyyymmdd ? 1 : 0

      return r1
    },
    getyearmonthday_com2 (day) {
      // 月曆年月日
      var calyyyymmdd = parseInt(String(this.yyyy1) + String(this.mm1).padStart(2, '0') + String(day).padStart(2, '0'))
      // 目前年月日
      var yyyymmdd = parseInt(String(this.yyyy) + String(this.mm).padStart(2, '0') + String(this.today1).padStart(2, '0'))
      var r1 = calyyyymmdd >= yyyymmdd ? 1 : 0

      console.log(r1)
      return r1
    },
    pageChange (obj) {
      this.yyyy1 = obj.year
      this.mm1 = obj.month
    },
    getDate1 (dt) {
      var date = null
      if (dt != null) {
        if (typeof dt === 'string') {
          date = new Date(dt)
        } else {
          date = dt
        }
      }
      var year = date.getFullYear()
      var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      var day = date.getDate() < 10 ? '0' + date.getDate() : '' + date.getDate()

      return tools.stringFormat('{0}{1}{2}', year - 1911, month, day)
    },
    show_Modal (id, date, day, orderid, ordstime, ordetime) {
      this.selectedDay = day
      this.ordstime = ordstime
      this.ordetime = ordetime

      var d = new Date()
      var today = d.getDate()
      console.log('aa=' + day >= today)
      console.log('bb=' + orderid == this.user.id)
      console.log('cc=' + this.user.id == 'Admin')

      if ((this.getyearmonthday_com2(today) && orderid == this.user.id) || (this.getyearmonthday_com2(today) >= today && this.user.id == 'Admin')) {
        this.editId = id
        this.date = date
        this.$refs.ePlace.show()
      }
    },
    hideModal () {
      this.$refs.ePlace.hide()
      this.getDate2()
    },
    getDate2 () {
      var vm = this
      this.days = []

      this.$http
        .get(
          './WebApi/Place/GetDateSet/'
            .concat(this.sysId)
            .concat('/' + this.placeno)
        )
        .then(function (response) {
          if (!tools.isNull(response.data)) {
            var len = response.data.length
            for (var i = 0; i < len; i++) {
              var tDay = response.data[i]
              vm.days.push({
                orderid: tDay.orderid,
                orderna: tDay.orderna,
                orderno: tDay.orderno,
                orderna: tDay.orderna,
                sdate: tDay.crE_DTE,
                mcarnum: tDay.mcarnum,
                ordstime: tDay.ordstime,
                ordetime: tDay.ordetime
              })
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('== OpenView ==')

    var dd = new Date()
    this.today1 = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
    this.mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
    this.yyyy = dd.getFullYear()

    const map1 = new Map([
      ['1110000', 14],
      ['1211000', 4],
      ['1611000', 9],
      ['2000000', 90],
      ['2100000', 150]
    ])

    this.maxcarnum = map1.get(this.placeno)

    this.getDate2()
    // var vm = this;
    // this.$http
    //   .get(
    //     "./WebApi/Setting/GetFormatInfo/".concat(this.sysId).concat("/" + this.maxcarnum)
    //   )
    //   .then(function (response) {
    //     vm.content = response.data;
    //    // vm.getDate1();
    //   })
    //   .catch(function (error) {
    //     tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
    //   });
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-red-600 {
  --bg-opacity: 1;
  background-color: #e53e3e;
  background-color: rgba(229, 62, 62, var(--bg-opacity));
}
.text-white1 {
  color: #e2e7bf;
  font-weight: bold;
  font-size: smaller;
}
.p-text {
  color: #7c1823;
  font-size: revert;
}
</style>
